import React from 'react';
import { Legend } from 'react-timeseries-charts';
import { legendStyle, legendLabelStyle } from './styles';
import { getCategories } from './i18n';

export default function ForecastLegend({ classes, lang, currentTech }) {
  const { forecastCategories } = getCategories(lang, currentTech);
  return (
    <Legend
      type="line"
      align="left"
      stack={true}
      style={legendStyle}
      labelStyle={legendLabelStyle}
      categories={forecastCategories}
      className={classes.timeplotLegend}
    />
  );
}
